import { environment } from '../../environments';
import { TranslateService } from 'ng2-translate/ng2-translate';


export const API = {
  ENDPOINT: {
    MEDIA: {
      GET: `${environment.apiEndpoint}media/`,
      UPLOAD: `${environment.apiEndpoint}media/upload/`,
      UPLOADFILE: `${environment.apiEndpoint}media/uploadfile`,
      UPLOADTHUMB: `${environment.apiEndpoint}media/uploadthumb/`,
      DELETE: `${environment.apiEndpoint}media/delete/`,
    },
    MAISVW: `${environment.apiEndpoint}cms/menus/`,
    NEWS: environment.apiEndpoint + 'news/',
    ACCESSORIES: `${environment.apiEndpoint}acessory/`,
    SELLERS: `${environment.apiEndpoint}sellers/`,
    USERS: `${environment.apiEndpoint}users/`,
    USERSAPP: `${environment.apiEndpoint}usersmobile/`,
    USERSAPPBR: `${environment.apiEndpoint}users_dealers/`,
    USERSAUDIT: `${environment.apiEndpoint}users_dealers/userauditcsv/`,
    USERSAPPSHARING: `${environment.apiEndpoint}users_sharing/`,
    VEHICLE: `${environment.apiEndpoint}vehicles/`,
    VEHICLENEWS: `${environment.apiEndpoint}vehicles_news/`,
    COLORS: `${environment.apiEndpoint}colors/`,
    CATEGORIES: `${environment.apiEndpoint}categories/`,
    COMPARE: `${environment.apiEndpoint}comparative/`,
    COMPARATIVEITEMS: `${environment.apiEndpoint}comparative_items/`,
    AUTHENTICATE: `${environment.apiEndpoint}authenticate/authenticateCMS`,
    LOGINIMAGE: environment.apiEndpoint + 'loginimage/',
    VERSIONS: environment.apiEndpoint + 'vehicles_versions/',
    PUSH: `${environment.apiEndpoint}push/`,
    REGIONS: `${environment.apiEndpoint}region/`,
    HOMEIMAGE: `${environment.apiEndpoint}homeimage/`,
  }
};

export const CRUD = {
  LIST: 'list',
  COPY: 'copy',
  PERSIST: 'persist/',
  CREATE: 'new/',
  EDIT: 'edit/',
  DELETE: 'delete/',
  UPDATE: 'updateOrder/'
}

export const EMPLOYEE_CATEGORIES = [
  {
    NAME: 'Horista',
    VALUE: 'vw-horist'
  },
  {
    NAME: 'Mensalista',
    VALUE: 'vw-monthly'
  },
  {
    NAME: 'Executivo',
    VALUE: 'vw-executive'
  }
];

export let VW_UNITS = [
  {
    NAME: 'Anchieta',
    VALUE: 'vw-anchieta'
  },
  {
    NAME: 'Taubaté',
    VALUE: 'vw-taubate'
  },
  {
    NAME: 'São Carlos',
    VALUE: 'vw-sao-carlos'
  },
  {
    NAME: 'Curitiba',
    VALUE: 'vw-curitiba'
  }
];

export let MODAL_MESSAGES = {
  ADD: {
    VALUE: 'add',
    TITLE: this.addtitle,
    TEXT: 'Adicionado com sucesso!',
    MODAL_TYPE: 'confirm'
  },
  EDIT: {
    VALUE: 'edit',
    TITLE: 'Editado',
    TEXT: 'Editado com sucesso!',
    MODAL_TYPE: 'confirm'
  },
  DELETE: {
    VALUE: 'delete',
    TITLE: 'Confirmar Remoção',
    TEXT: 'Você tem certeza que quer remover?',
    MODAL_TYPE: 'delete'
  },
  ERROR: {
    VALUE: 'error',
    TITLE: 'Erro',
    TEXT: 'Um erro aconteceu. Tente novamente.',
    MODAL_TYPE: 'confirm'
  },
  SESSION: {
    EXPIRED: {
      VALUE: 'error',
      TITLE: 'Sessão expirada',
      TEXT: 'Sua sessão expirou, por favor faça o login novamente.',
      MODAL_TYPE: 'confirm'
    }
  }
}

export const ALERT = {
  CONFIRM: {
    DEACTIVATE: {
      TITLE: '',
      MESSAGE: 'As mudanças não foram salvas. Tem certeza que gostaria de continuar?',
      BUTTON: {
        OK: 'Confirmar',
        CANCEL: 'Cancelar'
      }
    }
  },
  MEDIA: {
    DELETE: {
      TITLE: 'Deletar media',
      MESSAGE: 'Você tem certeza que deseja remover esta media? Esse processo é irreversível.',
      BUTTON: {
        OK: 'Deletar',
        CANCEL: 'Cancelar'
      }
    },
    ERROR: {
      TITLE: 'Erro no upload',
      MESSAGE: 'Não foi possível fazer o upload da sua media. Tente novamente mais tarde.',
      BUTTON: {
        OK: 'OK',
        CANCEL: ''
      }
    },
    MAXSIZE: {
      TITLE: 'Media inválida',
      MESSAGE: 'A media que você está tentando enviar excede o tamanho máximo permitido. Vídeos podem conter até 15mb e imagens até 2mb.',
      BUTTON: {
        OK: 'OK',
        CANCEL: ''
      }
    },
    INVALIDFILETYPE: {
      TITLE: 'Media inválida',
      MESSAGE: 'A media que você está tentando enviar não é do tipo PDF, ou excede o tamanho máximo permitido.',
      BUTTON: {
        OK: 'OK',
        CANCEL: ''
      }
    }
  }
};

export const PAGES = [
  {
    title: 'paneltitle-dashboard',
    link: '/dashboard',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-accessories',
    link: '/accessories',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-users',
    link: '/users',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-usersapp',
    link: '/usersapp',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-features',
    link: '/features',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-vehicle',
    link: '/vehicle',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-colors',
    link: '/colors',
    isActive: true,
    roles: [1, 2]
  },
  {
    title: 'paneltitle-versions',
    link: '/versions',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-vehiclenews',
    link: '/vehiclenews',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-compare',
    link: '/compare',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-comparativeitems',
    link: '/comparativeitems',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-push',
    link: '/push',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-homeImage',
    link: '/homeimage',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'Forum',
    link: '/forum',
    isActive: true,
    roles: [1, 2],
  },
  {
    title: 'paneltitle-maisvw',
    link: '/maisvw',
    isActive: true,
    roles: [1, 2, 3, 4],
  },
];

export const ROLES = [
  {
    TITLE: 'user-admin',
    ROLE: 'admin',
    VALUE: 1
  },
  {
    TITLE: 'user-admin-country',
    ROLE: 'admin-country',
    VALUE: 2
  },
  {
    TITLE: 'user-editor',
    ROLE: 'editor',
    VALUE: 3
  },
  {
    TITLE: 'app-mobile',
    ROLE: 'application',
    VALUE: 4
  }
];

export let PRIORITY_TYPES = [
  {
    NAME: 'Baixa',
    VALUE: '1'
  },
  {
    NAME: 'Média',
    VALUE: '2'
  },
  {
    NAME: 'Alta',
    VALUE: '3'
  }
];

export let CLUSTERS = [
  'Plano médico',
  'Apontadoria',
  'Documentação de pessoal',
  'Pagamento',
  'Telefones úteis',
  'VWPP e plano pecúlio',
  'Transporte'
];

export const CARS = {
  MODELS: [
    {
      value: 'hatch',
      label: 'Hatch'
    },
    {
      value: 'coupe',
      label: 'Coupe'
    },
    {
      value: 'pickup',
      label: 'Pick-Up'
    },
    {
      value: 'sedan',
      label: 'Sedan'
    },
    {
      value: 'stationwagon',
      label: 'Station Wagon'
    },
    {
      value: 'suv',
      label: 'SUV'
    }
  ]
};




// WEBPACK FOOTER //
// ./src/app/shared/constants.ts